import { t } from 'ttag';

import { EMAIL_MAX_LENGTH } from '../../lib/constants';

export const STATIC_ERROR_PHRASES = {
    EMAIL_ERROR: t`Помилка, невалідний емейл`,
    EMAIL_MAX_LENGTH_ERROR: t`Максимальна кількість символів - ${EMAIL_MAX_LENGTH}`,
    REQUIRED_FIELD_ERROR: t`Поле обов'язкове`,
    COMMON_ERROR: t`Йой! Щось пішло не так.`,
} as const;

export const HANDLED_ERRORS_BY_CODES = ['invalid_request'];

export const OBJECT_DOES_NOT_EXIST_ERROR_CODE = 'object_does_not_exist';
export const TOO_MANY_REQUEST_ERROR_CODE = 'too_many_request';
